<template>
    <div class="panel">
        <!-- <div
            @click="onSend"
            class="panel__item"
        >Создать предложение</div> -->
        <div class="panel__group-item">
            <div
                v-if="!isFound && !isShare"
                class="panel__item"
            >
                <BaseSwitch v-model="isEditMassModeProxy"/>
            </div>
            <div
                v-if="!isFound && !isShare"
                :class="[
                    'panel__item',
                    {
                        'panel__item--text': isEditMassModeProxy,
                        'panel__item--text-blocked': !isEditMassModeProxy
                    }
                ]"
                @click="onMoveToEditMass"
            >
                Массовое редактирование
            </div>
            <div
                class="panel__item panel__item--text"
                v-if="!isFound && !isShare && !isBusySides"
                @click="onMoveToBudget"
            >
                Редактирование цен
            </div>
            <div
                class="panel__item panel__item--text-blocked"
                v-tooltip="'В наборе есть проданные стороны. Если хотите перейти  в редактирование цен, удалите такие стороны.'"
                v-if="!isFound && !isShare && isBusySides"
            >
                Редактирование цен
            </div>

            <div class="panel__item panel__item--text" v-if="isFound && isAddAll" @click.stop="onAddAll">
                Добавить все
            </div>
        </div>
        <div class="panel__group-item">
            <div
                v-tooltip="'Скачать'"
                v-if="isExport"
                @click.stop="onExportExcel"
                class="panel__item panel__item--icon"
            >
                <LinceIconExport class="icon" :width="20" :height="20" />
            </div>
            <div
                v-tooltip="'Поделиться'"
                v-if="!isFound"
                @click.stop="onShare"
                class="panel__item panel__item--icon"
            >
                <LinceIconShare class="icon" :width="20" :height="20" />
            </div>
        </div>
        <div class="panel__group-item" v-if="isDuplicate || (!isShare && !isFound) || isRemove">
            <div
                v-if="isDuplicate"
                v-tooltip="'Дублировать'"
                class="panel__item panel__item--icon"
                @click.stop="onDuplicate"
            >
                <LinceIconSend class="icon" :width="20" :height="20" />
            </div>

            <div
                v-if="!isShare && !isFound"
                v-tooltip="'Удалить проданные стороны'"
                @click.stop="onRemoveBusySides"
                class="panel__item"
                :class="{
                    'panel__item--icon-blocked': !isBusySides,
                    'panel__item--icon': isBusySides
                }"
            >
                <LinceIconEraser class="icon" :width="20" :height="20" />
            </div>

            <div
                v-if="isRemove"
                v-tooltip="'Удалить'"
                @click.stop="onRemove"
                class="panel__item panel__item--icon"
            >
                <LinceIconTrash class="icon" :width="20" :height="20" />
            </div>
        </div>
        <div class="panel__group-item">
            <div
                v-if="isMinimizeMode"
                v-tooltip="'Свернуть в окно'"
                class="panel__item panel__item--icon"
                @click.stop="toMinimizeSize"
            >
                <LinceIconCollapse
                    :width="20"
                    :height="20"
                />
            </div>
            <div
                v-tooltip="'Расширить на половину экрана'"
                class="panel__item panel__item--icon"
                @click.stop="onFiftySize"
            >
                <LinceIconSizeHalf class="icon" :width="20" :height="20" />
            </div>
            <div
                v-tooltip="'Закрыть'"
                class="panel__item panel__item--icon"
                @click.stop="onCloseFolder"
            >
                <LinceIconClose :width="20" :height="20" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BaseSwitch from "@/components/Base/BaseSwitch.vue";

export default {
    name: "FolderControlPanel",
    components: {
        BaseSwitch
    },
    props: {
        isExport: {
            type: Boolean,
            default: false
        },
        isFound: {
            type: Boolean,
            default: false
        },
        isAddAll: {
            type: Boolean,
            default: true
        },
        isRemove: {
            type: Boolean,
            default: true
        },
        isDuplicate: {
            type: Boolean,
            default: false
        },
        isBusySides: {
            type: Boolean,
            default: false
        },
        isEditMassMode: {
            type: Boolean,
            default: false
        },
        isFull: {
            type: Boolean,
            default: true
        },
        isMinimizeMode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({ isShare: state => state.auth.isShare }),
        isEditMassModeProxy: {
            get() {
                return this.isEditMassMode;
            },
            set(isEditMassMode = false) {
                this.$emit("update:isEditMassMode", isEditMassMode);
            }
        }
    },
    methods: {
        onSend() {
            this.$emit("send");
        },
        async onExportExcel() {
            if (this.isBusySides) {
                // const isExport = confirm("Обратите внимание, в наборе есть проданные стороны. Вы хотите продолжить?");
                const isExport = await this.$confirm("Обратите внимание, в наборе есть проданные стороны. Вы хотите продолжить?");
                if (isExport)
                    this.$emit("exportExcel");
            } else
                this.$emit("exportExcel");
        },
        async onRemove() {
            // if (confirm("Вы уверены?")) this.$emit("remove");
            if (await this.$confirm("Вы уверены что хотите удалить набор?")) this.$emit("remove");
        },
        onAddAll() {
            this.$emit("addAll");
        },
        onMoveToEditMass() {
            this.$emit('moveToEditMass');
        },
        onMoveToBudget() {
            this.$emit("moveToBudget");
        },

        onRemoveBusySides(){
            if(this.isBusySides){
                this.$emit("onRemoveBusySides");
            }
        },

        onDuplicate() {
            this.$emit("onDuplicateKit");
        },
        onShare() {
            this.$emit("onShare");
        },
        onFullSize() {
            this.$emit("onFullSize");
        },
        onFiftySize() {
            this.$emit("onFiftySize");
        },
        toMinimizeSize() {
            this.$emit('toMinimizeSize');
        },
        onCloseFolder() {
            this.$emit("onCloseFolder");
        },
    }
};
</script>

<style lang="scss" scoped>
$gray-text: #b9bbc2;
$border-color: #EAECED;
$background-hover: #f2f2f2;
$blue-color: #4A92F6;
.panel {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &__group-item {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 0 15px;
        border-left: 1px solid $border-color;

        &:first-child {
            border-left: none;
        }

        &:last-child {
            padding-right: 0;
        }
    }

    &__item {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 36px;
        height: 36px;

        border-radius: 4px;
        cursor: pointer;
        transition: all .4s ease-out;

        &--text {
            width: auto;
            height: auto;
            color: #000;
            font-size: 12px;
            white-space: nowrap;
            margin-left: 10px
        }

        &--text-blocked {
            width: auto;
            height: auto;
            color: $gray-text;
            font-size: 12px;
            white-space: nowrap;
            margin-left: 10px;

            &:hover {
                color: $gray-text !important;
            }
        }

        &--icon {
            &:hover {
                background-color: $background-hover;
            }
        }

        &--icon-blocked {
            color: $gray-text;

            &:hover {
                background-color: $background-hover;
            }
        }

        &:hover {
            color: $blue-color;
        }
    }

    // .icon {
    //     transition: all .4s ease-out;
    //     ::v-deep path {
    //         fill: $gray-text;
    //     }

    //     &:hover {
    //        ::v-deep path {
    //             fill: #000;
    //         }
    //     }
    // }
}
</style>
